// take in is open, toggle is open and children

import { createContext, ReactElement, useContext } from 'react';

interface IPopupContextProps {
  isOpen: boolean;
  toggleIsOpen: (isOpen: boolean) => void;
}

const PopupContext = createContext<IPopupContextProps | undefined>(undefined);

const PopupProvider = ({
  children,
  isOpen,
  toggleIsOpen,
}: {
  children: ReactElement | null;
  isOpen: boolean;
  toggleIsOpen: (isOpen: boolean) => void;
}) => {
  return (
    <PopupContext.Provider value={{ isOpen, toggleIsOpen }}>
      {children}
    </PopupContext.Provider>
  );
};

const usePopupContext = () => {
  const context = useContext(PopupContext);
  if (context === undefined) {
    throw new Error('usePopupContext must be used within a PopupProvider');
  }
  return context;
};

export { PopupProvider, usePopupContext };
